import DownloadIcon from '@mui/icons-material/Download';
import { Button } from '@mui/material';

import { HeaderAction } from '@app/components/ListHeaderActions';

interface DownloadCsvButtonProps {
  action: HeaderAction;
}

export const DownloadCsvButton = ({ action }: DownloadCsvButtonProps) => {
  return (
    <Button
      data-cy="downloadCsv"
      variant="outlined"
      color="primary"
      sx={{ marginLeft: 2 }}
      startIcon={<DownloadIcon />}
      onClick={action.handler}>
      DOWNLOAD CSV
    </Button>
  );
};
